<div class="custom-not-available-error d-flex flex-row justify-content-center align-items-center vw-100 vh-100">
    
    <div class="d-flex flex-column justify-content-center align-items-center mx-auto w-50 h-50">
        <div class="custom-not-available-error-message d-flex flex-column justify-content-center align-items-center text-center">
            <span class="mb-2">La página del campus no está disponible.</span>
            <span class="mb-2">Por favor, inténtelo de nuevo más tarde.</span>
            <a mat-raised-button class="custom-not-available-error-button" [routerLink]="['/home']">
                <span class="material-icons">keyboard_backspace</span>
                Ir a la página principal
            </a>
        </div>
    </div>
    
</div>
